import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import ro from 'vuetify/es5/locale/ro'
import Scroll from 'vuetify/es5/directives/scroll'

Vue.use(Vuetify, {
  theme: {
    primary: '#FF5722',
    accent: '#212121',
    secondary: '#CDDC39',
    error: '#FF1744',
    warning: '#ff9800',
    info: '#03a9f4',
    success: '#4caf50'
  },
  options: {
    customProperties: true
  },
  iconfont: 'mdi',
  lang: {
    locales: { ro },
    current: 'ro'
  },
  directives: {
    Scroll
  }
})
